import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Table, Button, Alert, Form } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL;

function NewsManagement() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/news?admin=true`);
      setNews(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa tin tức này không?')) {
      try {
        await axios.delete(`${API_URL}/news/${id}`);
        setMessage('Tin tức đã được xóa thành công.');
        fetchNews(); // Refresh the list
      } catch (err) {
        setError(err);
        setMessage('Lỗi khi xóa tin tức.');
      }
    }
  };

  const handleChangeStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    try {
      await axios.put(`${API_URL}/news/${id}/status`, { status: newStatus, updated_by: 'admin' }); // Assuming 'admin' for now
      setMessage('Trạng thái tin tức đã được cập nhật.');
      fetchNews(); // Refresh the list
    } catch (err) {
      setError(err);
      setMessage('Lỗi khi cập nhật trạng thái tin tức.');
    }
  };

  if (loading) {
    return <Container className="mt-4">Đang tải tin tức...</Container>;
  }

  if (error) {
    return <Container className="mt-4"><Alert variant="danger">Lỗi: {error.message}</Alert></Container>;
  }

  return (
    <Container className="mt-4">
      <h2>Quản lý Tin tức</h2>
      <Button as={Link} to="/news/new" variant="primary" className="mb-3">
        Thêm Tin tức Mới
      </Button>
      {message && <Alert variant="info">{message}</Alert>}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Tiêu đề</th>
            <th>Trạng thái</th>
            <th>Ngày tạo</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {news.map((article) => {
            console.log(`News ID: ${article.id}, Status: ${article.status}, Type: ${typeof article.status}`);
            return (
              <tr key={article.id}>
                <td>{article.id}</td>
                <td>{article.title}</td>
                <td>
                  <Form.Check
                    type="switch"
                    id={`news-status-switch-${article.id}`}
                    label={article.status === 1 ? 'Hoạt động' : 'Không hoạt động'}
                    checked={article.status === 1}
                    onChange={() => handleChangeStatus(article.id, article.status)}
                    className="d-inline-block ms-2"
                  />
                </td>
                <td>{new Date(article.created_at).toLocaleDateString()}</td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    className="me-2"
                    onClick={() => navigate(`/news/${article.id}/edit`)}
                  >
                    Sửa
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    className="me-2"
                    onClick={() => handleDelete(article.id)}
                  >
                    Xóa
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
}

export default NewsManagement;
